import styles from './sceButton.scss';
import Enum from 'enum';

var buttonTypeEnum = new Enum({
    'scePrimary': 'sceBtnPrimary','sceSecondary': 'sceBtnSecondary','sceText': 'sceBtnText','sceLgPrimary': 'sceBtnLgPrimary','sceLgSecondary': 'sceBtnLgSecondary','sceLgText': 'sceBtnLgText','sceSmPrimary': 'sceBtnSmPrimary','sceSmSecondary': 'sceBtnSmSecondary','sceSmText': 'sceBtnSmText','scePrimaryDisabled': 'sceBtnPrimaryDisabled','sceSecondaryDisabled': 'sceBtnSecondaryDisabled','sceTextDisabled': 'sceBtnTextDisabled','sceLgPrimaryDisabled': 'sceBtnLgPrimaryDisabled', 'sceLgSecondaryDisabled': 'sceBtnLgSecondaryDisabled','sceLgTextDisabled': 'sceBtnLgTextDisabled','sceSmPrimaryDisabled': 'sceBtnSmPrimaryDisabled','sceSmSecondaryDisabled': 'sceBtnSmSecondaryDisabled','sceSmTextDisabled': 'sceBtnSmTextDisabled'
});
const SceButton = function (props) {
    const buttonTypeClass = styles[buttonTypeEnum.get(props.buttonType) + ''];
    const btnWithIcon = props.iconSrc ? <img className={styles.imageStylings} src={props.iconSrc} alt={props.alt} /> : "";
    const buttonVal = props.value;
    const btnwithLftIcon = props.iconLeftSrc ? <img className={styles.imageLeftStylings} src={props.iconLeftSrc} alt={props.alt} /> : "";
    return (
        <button type='button' tabIndex={props.tabId} onMouseOver={props.handleRefreshButtonOver} onMouseOut={props.handleRefreshButtonOut} disabled={props.isDisabled} className={[buttonTypeClass, styles.sceButton].join(' ')} id={props.id} onClick={props.onClick} onMouseDown={props.onMouseDown}>{btnwithLftIcon}<strong>{buttonVal}</strong>{btnWithIcon}</button>
    );
};
export default SceButton;
SceButton.defaultProps = {
    buttonType: 'sceBtnPrimary',
    isDisabled: false,
    id: '',
    name: '',
    tabId:'0'
};

